import { Button, Modal, Spinner } from "@heroui/react";
import { PropsWithChildren } from "react";

// 对话框参数
export interface ModalProps extends PropsWithChildren {
  open: boolean;
  showHeader?: boolean;
  title?: string;
  description?: string;
  showCancel?: boolean;
  showConfirm?: boolean;
  confirmLoading?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  onClose?: () => void;
}

// 基础Modal布局
const BaseModal = ({
  open = true,
  showHeader,
  title,
  description,
  showCancel = true,
  showConfirm = true,
  confirmLoading,
  onCancel,
  onConfirm,
  onClose,
  children,
}: ModalProps) => {
  return (
    <Modal.Backdrop
      isOpen={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose?.();
        }
      }}
    >
      <Modal.Container placement="center" size="sm">
        {/* 移动端优化的内容区域 */}
        <Modal.Dialog className="max-h-[80vh] w-[85vw] max-w-[400px] rounded-2xl p-4">
          {/* 头部区域 */}
          {showHeader && (
            <Modal.Header>
              {title && <Modal.Heading>{title}</Modal.Heading>}
              {description && (
                <p className="mt-2 text-sm leading-relaxed text-muted">{description}</p>
              )}
            </Modal.Header>
          )}

          {/* 内容区域 */}
          {children && <Modal.Body>{children}</Modal.Body>}

          {/* 底部按钮区域 */}
          {(showConfirm || showCancel) && (
            <Modal.Footer className="flex w-full flex-row gap-3">
              {showCancel && (
                <Button variant="outline" className="flex-1 rounded-full" onPress={onCancel}>
                  取消
                </Button>
              )}
              {showConfirm && (
                <Button
                  className="flex-1 rounded-full"
                  isPending={confirmLoading}
                  onPress={onConfirm}
                >
                  {({ isPending }) => (
                    <>
                      {isPending && <Spinner size="sm" color="current" />}
                      确定
                    </>
                  )}
                </Button>
              )}
            </Modal.Footer>
          )}
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
};

export default BaseModal;
